export const getUsableChatFieldIds = (fieldValues = {}) =>
	Object.entries(fieldValues || {})
		.filter(([, value]) =>
			value !== undefined &&
			value !== null &&
			value !== "" &&
			(!Array.isArray(value) || value.length > 0),
		)
		.map(([key]) => key);
